module.exports = __webpack_public_path__ + "img/img-142.8b47aca3.png";